import {Component, OnInit, OnDestroy, HostListener, ChangeDetectorRef} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {BUSINESS_COLOR, SHOW_SETTING, SHOW_VOIP} from "../../app.constants";
import {AccountService} from "../../singelton/account.service";
import {IMessage} from "../../shared/model/chat.message.model";
import {ICallReportModel} from "../../shared/model/callReport.model";
import {IPhone} from "../../shared/model/phone.model";
import {CallService} from "../../entities/Report/call-report.service";
import {HttpResponse} from "@angular/common/http";
import {isNullOrUndefined} from "@swimlane/ngx-datatable/release/utils";
import * as moment from 'jalali-moment';
import {FeatureFlagsService} from "../../singelton/feature-flags.service";
import {EventService} from "../../singelton/event.service";
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit, OnDestroy {
  // color = 'default';
  show_voip: any = SHOW_VOIP;

  // color = 'greendark';
  show_setting: any = SHOW_SETTING;
  business_color: any = BUSINESS_COLOR;
  color = this.business_color;
  messages : IMessage[];
  calls : Array<ICallReportModel> = Array();
  showSettings = false;
  showMinisidebar = false;
  showDarktheme = false;
  showDiv = false;
  showRtl = true;
  public innerWidth: any;
  private readonly mobileBreakpoint = 768;
  private routerSub: Subscription;

  public config: PerfectScrollbarConfigInterface = {};

  /** Mobile drawer is open when sidebar is not in mini (hidden) mode */
  get isMobileSidebarOpen(): boolean {
    return this.innerWidth < this.mobileBreakpoint && !this.showMinisidebar;
  }

  syncFeatureFlags() {
    this.show_voip = this.featureFlags.flags.showVoip;
    this.show_setting = this.featureFlags.flags.showSetting;
  }

  constructor(public router: Router,
              public accountService: AccountService,
              public changeDetectorRef: ChangeDetectorRef,
              public callService: CallService,
              private featureFlags: FeatureFlagsService,
              private eventService: EventService) {

    this.syncFeatureFlags();
    this.eventService.changeSettingEvantAdd.subscribe(() => {
      this.featureFlags.load();
      setTimeout(() => this.syncFeatureFlags(), 300);
    });

    this.accountService.chatMessageAdded.subscribe((data) => {

      // reading content of the received message
      let m : IMessage;

      console.log(" ----  >>>>>> o O " + data)

      m = JSON.parse(data);

      //check different types of notifications
      if(m.type === "CALL_CENTER_NOTIFICATION") {
        let call :ICallReportModel;

        let phone :IPhone[];

        call = JSON.parse(m.content);

  //     phone = JSON.parse(call.phones)

       //  alert(" ----- >>>> phonesssss : " + call);
       //  alert(" ----- >>>> phonesssss : " + call.phones[0].customer.id);
        // alert(" ----- >>>> phonesssss : " + call.phones.length);
        //
        // if(!this.showDiv)
        // this.calls.push(call);
        // else
         this.calls.unshift(call);

       // this.changeDetectorRef.markForCheck()
        //this.calls=this.calls.slice();


        // open the phone side bar if it is closed
        this.openAutoMsgArrived()

      }

    });

  }

  ngOnInit() {
    if (this.router.url === '/') {
      this.router.navigate(['/dashboard/dashboard']);
    }
    this.handleLayout();
    this.syncFeatureFlags();

    if (this.showRtl) {
      sessionStorage.setItem('lang', 'fa');
    } else {
      sessionStorage.setItem('lang', 'en');
    }

    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.closeMobileSidebar());
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  openAutoMsgArrived(){
    if(!this.showDiv)
    {
      // todo comment showDiv call anutomatic for parse
      // this.showDiv = true;


      //fetch the latest when open the calls tab (when the tab is going to open the last element of synchronous api should be deleted to prevent duplication)
      this.loadLastFiveMinusLatest();
    }
}

  showDivf() {
    if(!this.showDiv) {

      // truncate the array to fill compeletly from the server (when open the tab manually)
      this.calls = [];

      //fetch the latest when open the calls tab
      this.loadLastFive();
      this.showDiv = true;

    } else {
      this.showDiv = false;
      // truncate the array when close the sidebar
      this.calls = [];
    }
  }

  onSuccess(data, headers, startIndex) {
    //this.calls = data;
   // alert(" --- >>>>> received data   :    "  + data.length);

    for (let i = startIndex; i < 5; i++) {
      if (!isNullOrUndefined(data[i]))
        this.calls.push(data[i]);
    }
    this.changeDetectorRef.markForCheck()

  }

  onError(error){
  }

  loadLastFive(){
    this.callService.queryForFive({
      page: 0,
      size: 5,
      sort: ['id,desc']
    })
      .subscribe((res: HttpResponse<ICallReportModel[]>) => this.onSuccess(res.body, res.headers, 0), (res: HttpResponse<any>) => this.onError(res.body));

  }

  loadLastFiveMinusLatest(){
    this.callService.queryForFive({
      page: 0,
      size: 5,
      sort: ['id,desc']
    })
      .subscribe((res: HttpResponse<ICallReportModel[]>) => this.onSuccess(res.body, res.headers, 1), (res: HttpResponse<any>) => this.onError(res.body));

  }

  hideDivf() {
    this.showDiv = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleLayout();
  }

  toggleSidebar() {
    this.showMinisidebar = !this.showMinisidebar;
  }

  closeMobileSidebar() {
    if (this.innerWidth < this.mobileBreakpoint) {
      this.showMinisidebar = true;
    }
  }

  onSidebarNavClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target) {
      return;
    }
    const link = target.closest('a') as HTMLAnchorElement;
    if (!link) {
      return;
    }
    // Parent accordion toggles keep the drawer open
    if (link.classList.contains('has-arrow')) {
      return;
    }
    // Leaf menu item — close drawer (NavigationEnd also closes)
    setTimeout(() => this.closeMobileSidebar(), 80);
  }

  handleLayout() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1170) {
      this.showMinisidebar = true;
    } else {
      this.showMinisidebar = false;
    }
  }

  parseDate(value) {
    // alert(' val ' + value);
    let jalaliDate5 = '-';
    if (value) {
      // jalaliDate5 = moment(value).locale('fa').format('jYYYY/jM/jD HH:mm'); // 1367/11/4
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    } // 1367/11/4


    // alert(' jalaliDate5 ' + jalaliDate5);

    return jalaliDate5;
  }

}
